import { FormContext, FormGroup, FormLabel, Slider } from '@hai/ui-react';
import classNames from 'classnames';
import { FormikProps } from 'formik';
import { isNil } from 'ramda';
import React, { ReactNode } from 'react';
import { FormTextfield } from './form-textfield';

export interface Props {
  title?: string;
  name?: string;
  min?: number | string;
  max?: number | string;
  step?: number | string;
  disabled?: boolean;
  className?: string;
  showRange?: boolean | any;
  onChange?: Function;
  withValueInput?: boolean;
  valueInputStyle?: any;
  inputValueSuffix?: string | ReactNode;
}

export const FormSlider = (props: Props) => {
  const {
    title,
    name,
    disabled = false,
    className = '',
    onChange,
    withValueInput,
    valueInputStyle,
    inputValueSuffix,
    showRange = false,
    ...rest
  } = props;

  return (
    <FormContext.Consumer>
      {(formContext: FormikProps<any>) => {
        // If HAIUI ever handles this internally for checkbox we could remove this block of formik code
        const meta = formContext?.getFieldMeta(name);
        const helper = formContext?.getFieldHelpers(name);
        const formikValue = meta?.touched ? meta.value : meta?.initialValue;
        const onChangeLocal = (checked: boolean) => {
          if (!isNil(name)) {
            helper?.setTouched(true);
            helper?.setValue(checked);
          }
          onChange?.(checked);
        };
        return (
          <FormGroup className={className}>
            {title && <FormLabel>{title}</FormLabel>}
            <div className={classNames('mk-slider', showRange && 'with-range')}>
              <Slider
                name={name}
                defaultValue={formikValue}
                disabled={disabled}
                onChange={onChangeLocal}
                showRange={showRange}
                withTooltip={false}
                //  withValueInput
                //   valueInputStyle={{ style: '60px' }}
                {...rest}
              />
              {withValueInput && <FormTextfield name={name} style={valueInputStyle} type="number" />}
              {inputValueSuffix}
            </div>
          </FormGroup>
        );
      }}
    </FormContext.Consumer>
  );
};
